import { bolAwbFields } from './bolAwbForm'

export const cargoReleaseUpdateFields = {
  signSection: true,
  centralizedExaminationSite: true,
  importArrivalDateEnabled: true,
  locationOfGoods: true,
  boltype: true,
  bolnumber: true,
  bolHouseNumber: true,
  vesselCode: true,
  tripInformation: true,
  splitBill: true,
  'manifestQuantity.Quantity': true,
  'manifestQuantity.Units': true,
  bondWaiverReasonCode: true,
  bondType: false,
  suretyNumber: false,
  bondValue: false,
  manufacturerId: false,
  singleTransactionBondProducerAccountNumber: true,
  USportOfUnladingCode: true,
  flightNo: true,
  conveyanceName: true,
  entryTypeSection: false,
  countryOfExportEnabled: false,
  portOfEntryCodeEnabled: true,
  engineBolFormEnabled: true,
  entryTypeEntryDateEnabled: false,
  importingCarrier: true,
  modeOfTransport: true,
  itNumber: true,
  goNumberDisable: true,
  portCodeHeader: false,
  adcvdSectionEnabled: false,
  voluntaryAdcvdSectionEnabled: true,
  itDate: true,
  voyageNo: true,
  containerSize: true,
  containerNo: true,
  removeContainer: true,
  addContainer: true,
  'grossWeight.weight': false,
  nonAms: true,
  commercialDescriptionSkuEnabled: false,
  taxFieldsAreEnabled: false,
  additionalFeeFieldsAreEnabled: false,
  addRemoveMerchandiseLineItems: false,
  pgasAreEnabled_m: false,
  aluminiumSmeltAndCast: true
}
export const cargoReleaseStandaloneUpdateFields = {
  signSection: true,
  centralizedExaminationSite: true,
  commercialDescriptionSkuEnabled: true,
  locationOfGoods: true,
  boltype: true,
  portCodeHeader: true,
  bolnumber: true,
  bolHouseNumber: true,
  vesselCode: true,
  tripInformation: true,
  splitBill: true,
  'manifestQuantity.Quantity': true,
  'manifestQuantity.Units': true,
  bondWaiverReasonCode: true,
  bondType: true,
  suretyNumber: true,
  bondValue: true,
  manufacturerId: true,
  singleTransactionBondProducerAccountNumber: true,
  adcvdSectionEnabled: false,
  voluntaryAdcvdSectionEnabled: true,
  USportOfUnladingCode: true,
  flightNo: true,
  conveyanceName: true,
  entryTypeSection: false,
  countryOfExportEnabled: true,
  portOfEntryCodeEnabled: true,
  entryTypeEntryDateEnabled: false,
  engineBolFormEnabled: true,
  importingCarrier: true,
  modeOfTransport: true,
  itNumber: true,
  goNumberDisable: true,
  itDate: true,
  voyageNo: true,
  containerSize: true,
  containerNo: true,
  removeContainer: true,
  addContainer: true,
  'grossWeight.weight': true,
  permitTypeEnabled: false,
  taxFieldsAreEnabled: true,
  additionalFeeFieldsAreEnabled: true,
  addRemoveMerchandiseLineItems: true,
  pgasAreEnabled_m: true,
  reconciliationIssueCode: false
}